export default function SectionHdr({ pill, title, sub, action, onAction, rightContent }) {
    return (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginBottom: 10 }}>
            <div>
                {pill && (
                    <div style={{
                        display: "inline-flex", alignItems: "center", gap: 6,
                        background: "linear-gradient(135deg, #8B1A1A, #C0392B)",
                        color: "white", fontSize: 11, fontWeight: 800,
                        padding: "5px 14px", borderRadius: 50, marginBottom: 12,
                        letterSpacing: "0.08em",
                        boxShadow: "0 2px 12px rgba(192,57,43,0.3)"
                    }}>{pill}</div>
                )}
                {title && (
                    <h2 style={{
                        fontSize: 32, fontWeight: 800, color: "var(--ink)",
                        letterSpacing: "-0.02em", lineHeight: 1.15
                    }}>{title}</h2>
                )}
                {sub && (
                    <p style={{ fontSize: 15, color: "var(--text3)", marginTop: 6, lineHeight: 1.6 }}>{sub}</p>
                )}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                {rightContent}
                {action && (
                    <button
                        onClick={onAction}
                        style={{
                            whiteSpace: "nowrap", flexShrink: 0,
                            padding: "8px 18px", borderRadius: 8, fontSize: 13, fontWeight: 700,
                            background: "transparent", border: "1.5px solid #C0392B",
                            color: "#C0392B", cursor: "pointer", transition: "all 0.2s",
                            fontFamily: "'Nunito Sans',sans-serif",
                        }}
                        onMouseEnter={e => { e.currentTarget.style.background = "#C0392B"; e.currentTarget.style.color = "white"; }}
                        onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#C0392B"; }}
                    >{action} →</button>
                )}
            </div>
        </div>
    );
}